import { Switch } from 'react-router';
import type { Location as RouterLocation } from 'history';
import { useSelector } from 'react-redux';
import { PropsRoute } from '@makemydeal/dr-activities-common';
import { getAllRoutes } from '../utils/routes';

// Import components from sales-checkin-components library
import { GlobalError, DealSetupScreen } from '@makemydeal/dr-sales-checkin-components';
import { RoleAssumption } from '@makemydeal/dr-activities-role-assumption';

import { ROOT_ROUTE } from '../../../constants';
import Dashboard from '../components/dashboard/Dashboard';
import { useCancelLoadTelemetryOnViewAsStart } from './useCancelLoadTelemetryOnViewAsStart';

/**
 * Global Router Component for Sales Check-in Application
 * Handles global routes at app level and delegates routing to activities library.
 */
const GlobalRouter = () => {
    const routes = getAllRoutes(ROOT_ROUTE);

    // Match against the store's location, not react-router's context: navigationMiddleware can
    // navigate before the shell mounts, leaving the context on "/" for the first render — which fell
    // through to the catch-all ROOT route and flashed the Showroom shell before the real route.
    // The `router` slice is injected by connected-react-router, so it isn't in the app state type.
    const storeLocation = useSelector((state: { router?: { location?: RouterLocation } }) => state.router?.location);

    const pathname = storeLocation?.pathname ?? window.location.pathname;
    useCancelLoadTelemetryOnViewAsStart(pathname === routes.ROLE_ASSUMPTION);

    return (
        <Switch location={storeLocation}>
            <PropsRoute exact path={routes.ROLE_ASSUMPTION} component={RoleAssumption} />
            <PropsRoute exact path={routes.APP_ERROR} component={GlobalError} />
            <PropsRoute exact path={routes.DEAL_SETUP} component={DealSetupScreen} />
            <PropsRoute path={routes.ROOT} component={Dashboard} />
        </Switch>
    );
};

export default GlobalRouter;
